import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIE: CultureInfo = {
  name: 'en-IE',
  displayName: 'English (Ireland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IE',
  parent: CultureInfoEn
};
